import React from "react";
import { Autocomplete } from "../core";
import { useStyles } from "../AppTextField/style";

export const AppAutocomplete = (props) => {
  const classes = useStyles();
  return <Autocomplete className={classes.textField} {...props} />;
};
